import { observer } from 'mobx-react';
import { Document } from '@roc/feature-types';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { useStore } from '@roc/client-portal-shared/hooks';
import { BankStatementDashboard } from './bankStatementDashboard';

export interface BorrowerLiquidityDialogProps {
  open: boolean;
  onClose: () => void;
  document?: Document;
}

export const BorrowerLiquidityDialog = observer(
  ({ open, onClose, document }: BorrowerLiquidityDialogProps) => {
    const { docReviewStoreV2 } = useStore();
    const uploadLocked = docReviewStoreV2.isUploadLocked(document);

    return (
      <>
        {document?.taskId && (
          <CustomTaskDialog
            open={open}
            title="Borrower Liquidity"
            handleClose={onClose}
            taskId={document?.taskId}
            maxWidth="lg"
            allowVertScroll={false}
            dialogContent={
              <BankStatementDashboard
                loanId={document?.loanId}
                borrowerId={document?.borrowerId}
                hideUpload={uploadLocked}
              />
            }
          />
        )}
      </>
    );
  }
);
